import Button from "common/components/Button/Button"
import DireccionInputs from "common/components/FormikFields/DireccionInputs"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import MapDisplay from "common/components/MapDisplay"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import * as Validations from "common/utils/formValidations"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const mapValuesToApi = (values: $TSMigrationFixMe) => {
  let addressMapped = {
    calle: values?.direccion,
    codigoPostal: values?.cp,
    esFiscal: values.esFiscal,
    id: values?.id,
    empresaId: values?.empresaId,
  }
  if (values?.countrySelected === DEFAULT_COUNTRY_SELECTED) {
    addressMapped = {
      ...addressMapped,
      // @ts-expect-error TS(2322): Type '{ poblacionId: $TSFixMe; provinciaId: $TSFixMe; calle:...
      poblacionId: values?.poblacionId || 0,
      provinciaId: values?.provinciaId || 0,
    }
  } else {
    addressMapped = {
      ...addressMapped,
      // @ts-expect-error TS(2322): Type '{ poblacionExtranjera: $TSFixMe; calle: $TSFixMe; codi...
      poblacionExtranjera: values?.poblacionExtranjera,
    }
  }
  return addressMapped
}

const DireccionSocialForm = ({
  values,
  setFieldValue,
  initialValues,
  handleSubmit,
  isValid,
  dirty,
  onHide,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const address = `${values?.direccion} - ${values?.cp}`

  return (
    <form onSubmit={handleSubmit}>
      <div className='tw-text-left'>
        <div className='tw-w-full'>
          <FormikInputText
            className='tw-w-full'
            name='direccion'
            id='direccion'
          />
        </div>

        <div className='tw-mt-4 tw-flex tw-flex-col lg:tw-flex-row lg:tw-space-x-2'>
          <DireccionInputs
            className=' tw-text-left tw-w-full'
            initialCodigoPostal={initialValues.cp}
            showProvincia={false}
            setFieldValue={setFieldValue}
            otherCountries={
              initialValues.countrySelected !== DEFAULT_COUNTRY_SELECTED
            }
            countrySelected={initialValues.countrySelected}
            cpValue={values.cp}
            provinciaValue={values.provincia}
            poblacionValue={values.poblacion}
          />
        </div>

        <MapDisplay
          postalCode={values?.cp}
          address={address}
        />

        <div className='tw-mt-4 tw-w-full tw-flex tw-justify-end'>
          <Button
            className='tw-mr-4 text'
            onClick={onHide}
          >
            {t("contactos.editar.modal.cancelButton")}
          </Button>
          <Button
            className='!tw-bg-primary'
            onClick={handleSubmit}
            disabled={!(isValid && dirty)}
          >
            {t("contactos.editar.modal.saveButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    direccion: Yup.string().required(t("errors.directionEmpty")),
    cp: Yup.string().when("isSpain", {
      is: (isSpain: $TSMigrationFixMe) => isSpain === true,
      then: Validations.validateCodigoPostal(t),
    }),
  })
export const validateFn = (
  t: $TSMigrationFixMe,
  { codigoPais, poblacionId }: $TSMigrationFixMe
) => {
  const errors = {}

  if (!poblacionId && codigoPais === DEFAULT_COUNTRY_SELECTED) {
    // @ts-expect-error TS(2339): Property 'poblacionId' does not exist on type '{}'...
    errors.poblacionId = `${t("errors.selectedPoblation")}`
  }

  return errors
}

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, countrySelected, empresaId }) => ({
    direccion: data?.calle,
    esFiscal: data?.esFiscal,
    cp: data?.codigoPostal,
    poblacion: data?.poblacionNombre,
    provincia: data?.provinciaNombre,
    poblacionId: data?.poblacionId,
    provinciaId: data?.provinciaId,
    nuevo: data?.nuevo,
    id: data?.id,
    poblacionExtranjera: data?.poblacionExtranjera,
    countrySelected,
    isSpain: countrySelected === DEFAULT_COUNTRY_SELECTED,
    empresaId,
  }),
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateFn(t, rowData),
  enableReinitialize: true,
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    const data = mapValuesToApi(values)

    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(data)
  },
})(DireccionSocialForm)

export default Form
